"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-outlined-open-in-new.tsx
var OpenInNew = function OpenInNew(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "currentColor",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M8.66699 2.5H14.0003V7.83333",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), (0, _preact.h)("path", {
    d: "M14 11.7308V12.6538C14 13.1435 13.8055 13.6131 13.4593 13.9593C13.1131 14.3055 12.6435 14.5 12.1538 14.5L3.84615 14.5C3.35652 14.5 2.88695 14.3055 2.54073 13.9593C2.1945 13.6131 2 13.1435 2 12.6538L2 4.34615C2 3.85652 2.1945 3.38695 2.54073 3.04073C2.88695 2.69451 3.35652 2.5 3.84615 2.5H4.76923",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), (0, _preact.h)("path", {
    d: "M14 2.5L6 10.5",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var _default = OpenInNew;
exports.default = _default;